<template>
  <t-form ref="form" class="contact-pro-form" @submit.prevent>
    <t-text-field
      v-model="companyName"
      class="contact-pro-form__company"
      :placeholder="$t('field.company-name.placeholder')"
      autocomplete="organization"
      :error-messages="companyNameErrors"
      type="text"
      @blur="validateCompanyName"
    />

    <t-text-field
      v-model="phone"
      class="contact-pro-form__phone"
      :placeholder="$t('field.phone.placeholder')"
      inputmode="tel"
      autocomplete="tel"
      :error-messages="phoneErrors"
      @blur="validatePhone"
    />

    <t-text-field
      v-model="contactName"
      class="contact-pro-form__contact"
      :placeholder="$t('field.contact-name.placeholder')"
      autocomplete="name"
      :error-messages="contactNameErrors"
      type="text"
      @blur="validateContactName"
    />

    <t-text-field
      v-model="email"
      class="contact-pro-form__email"
      :placeholder="$t('field.email.placeholder')"
      type="email"
      inputmode="email"
      autocomplete="email"
      :error-messages="emailErrors"
      @blur="validateEmail"
    />

    <t-btn
      id="submitContactProForm"
      class="contact-pro-form__submit-btn"
      color="primary"
      :disabled="submitBtnIsDisabled"
      @click="onSubmit"
    >
      {{ $t('global.contact-us') }}
    </t-btn>
  </t-form>
</template>

<script>
import ValidationRules from 'chimera/all/functions/ValidationRules'
import AbstractContactForm from './AbstractContactForm'

export default {
  name: 'ContactProForm',

  extends: AbstractContactForm,

  props: {
    conversionName: {
      type: String,
      default: 'contact-pro-form',
    },

    hubspotFormId: {
      type: String,
      default: 'a2357ff6-69da-4774-ab07-224bc1f90928',
    },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      companyName: '',
      companyNameErrors: [],
      companyNameRules: [
        (v) => !!v || this.$i18n.t('field.company-name.validation.required'),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === '0-2/name')
            .length === 0 ||
          this.$i18n.t('field.company-name.validation.invalid'),
      ],
      phone: '',
      phoneErrors: [],
      phoneRules: [
        (v) => !!v || this.$i18n.t('field.phone.validation.required'),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'phone')
            .length === 0 || this.$i18n.t('field.phone.validation.invalid'),
      ],
      contactName: '',
      contactNameErrors: [],
      contactNameRules: [
        (v) => !!v || this.$i18n.t('field.contact-name.validation.required'),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'firstname')
            .length === 0 ||
          this.$i18n.t('field.contact-name.validation.invalid'),
      ],
      email: '',
      emailErrors: [],
      emailRules: [
        (v) => !!v || this.$i18n.t('field.email.validation.required'),
        ...ValidationRules.isEmailFormat(
          this.$i18n.t('field.email.validation.invalid'),
        ),
        (v) =>
          this.hubspotErrors.filter((error) => error.field === 'email')
            .length === 0 || this.$i18n.t('field.email.validation.invalid'),
      ],
    }
  },

  methods: {
    /**
     * @returns {Array}
     */
    getFormFields() {
      return [
        {
          name: '0-2/name',
          value: this.companyName,
        },
        {
          name: 'firstname',
          value: this.contactName,
        },
        {
          name: 'email',
          value: this.email,
        },
        {
          name: 'phone',
          value: this.phone,
        },
      ]
    },

    /**
     * Validate form
     *
     * @returns {boolean}
     */
    validateForm() {
      const allErrors = [
        ...this.validateCompanyName(),
        ...this.validateContactName(),
        ...this.validatePhone(),
        ...this.validateEmail(),
      ]
      return allErrors.length === 0
    },

    /**
     * Validate company name
     *
     * @returns {Array} errors
     */
    validateCompanyName() {
      this.companyNameErrors = ValidationRules.evaluate(
        this.companyNameRules,
        this.companyName,
      )
      return this.companyNameErrors
    },

    /**
     * Validate contact name
     *
     * @returns {Array} errors
     */
    validateContactName() {
      this.contactNameErrors = ValidationRules.evaluate(
        this.contactNameRules,
        this.contactName,
      )
      return this.contactNameErrors
    },

    /**
     * Validate phone
     *
     * @returns {Array} errors
     */
    validatePhone() {
      this.phoneErrors = ValidationRules.evaluate(this.phoneRules, this.phone)
      return this.phoneErrors
    },

    /**
     * Validate email
     *
     * @returns {Array} errors
     */
    validateEmail() {
      this.emailErrors = ValidationRules.evaluate(this.emailRules, this.email)
      return this.emailErrors
    },
  },
}
</script>
